export function buildImageUrl(url: string, maxSize: number | undefined, defaultMaxSize: number) {
    if (!/^https:\/\/image\.api\..*gotombola\.co\//.test(url)) return url;
    return `${url}${url?.indexOf('?') > -1 ? '&' : '?'}size_enlarge=0&size=${
        undefined !== maxSize ? Math.min(maxSize, defaultMaxSize) : defaultMaxSize
    }`;
}

export default buildImageUrl;
